import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">About BuildNex</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="about-content">
          <div className="about-text">
            <p className="about-description">
              At BuildNex, we are committed to delivering exceptional services that drive
              business growth and innovation. With years of industry experience and a team
              of dedicated professionals, we transform challenges into opportunities.
            </p>
            <p className="about-description">
              Our mission is to provide tailored solutions that meet the unique needs of
              each client, ensuring quality, reliability, and excellence in every project
              we undertake.
            </p>
            
            <div className="stats-grid">
              <div className="stat-card">
                <h3 className="stat-number">200+</h3>
                <p className="stat-label">Projects Completed</p>
              </div>
              <div className="stat-card">
                <h3 className="stat-number">100+</h3>
                <p className="stat-label">Happy Clients</p>
              </div>
              <div className="stat-card">
                <h3 className="stat-number">20+</h3>
                <p className="stat-label">Team Members</p>
              </div>
              <div className="stat-card">
                <h3 className="stat-number">10+</h3>
                <p className="stat-label">Years Experience</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
